/// <amd-module name="VSSUI/Surface" />
export { Surface, SurfaceContext } from "./Components/Surface/Surface";
export { Spacing, ISurfaceProps, SurfaceBackground } from "./Components/Surface/Surface.Props";
